/**
 * Koduje "/" na "%2F" w przekazanym ciągu.
 *
 * @param {string} str - string do zakodowania
 * @return {string}
 */
const codeSlash = str => str.replace(/\//g, '%2F');

export default codeSlash;
